import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentUser } from "appRedux/slices/currentUser"
import _Get from "lodash/get"
import Spinner from "components/Spinner/Spinner"
import { Switch, BrowserRouter as Router } from "react-router-dom"

// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes/AppRoutes"
import { Redirect } from "react-router-dom"
// Import all middleware
import Authmiddleware from "./routes/AuthMiddleware"

import TimeAgo from "javascript-time-ago"
import en from "javascript-time-ago/locale/en"
TimeAgo.addDefaultLocale(en)

import "./util/lodash_mixins"
// Import scss
import "./assets/scss/theme.scss"

const App = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCurrentUser())
  }, [dispatch])

  const { loading, currentUser, dataFetched } = useSelector(
    state => state.currentUser
  )

  const getProtectedRoutes = routes => {
    let protectedRoutes = []
    routes.sort((menu, next_menu) => {
      if (menu.title < next_menu.title) {
        return -1
      }
      if (menu.title > next_menu.title) {
        return 1
      }
      return 0
    })
    routes.map((route, idx) =>
      protectedRoutes.push(
        <Authmiddleware
          path={route.path}
          component={route.component}
          route={route}
          currentUser={currentUser}
          key={idx}
          parentRoute={route}
          isAuthProtected={true}
          exact
        />
      )
    )
    return protectedRoutes
  }

  if (!loading && dataFetched) {
    if (currentUser && currentUser.data) {
      return (
        <Router>
          <Switch>
            {getProtectedRoutes(authProtectedRoutes).map(route => route)}
            <Redirect to="/dashboard/home" />
          </Switch>
        </Router>
      )
    }
    // else if(currentUser && currentUser.data && currentUser.data.length === 0) {
    //   <div>Hi</div>
    // }
    else {
      return (
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                component={route.component}
                key={idx}
                currentUser={currentUser}
                route={route}
                isAuthProtected={false}
                exact
              />
            ))}
            <Redirect to="/login" />
          </Switch>
        </Router>
      )
    }
  }

  return <Spinner />
  // return (
  //   <Router>
  //     <Switch>
  //       {publicRoutes.map((route, idx) => (
  //         <Authmiddleware
  //           path={route.path}
  //           component={route.component}
  //           key={idx}
  //           // currentUser={currentUser}
  //           route={route}
  //           isAuthProtected={false}
  //           exact
  //         />
  //       ))}
  //       <Redirect to="/login" />
  //     </Switch>
  //   </Router>
  // );
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
